export default __webpack_public_path__ + "static/media/arrow-down.9ff133ba.svg";